import { render, staticRenderFns } from "./SizeGuide.vue?vue&type=template&id=837e864c&"
import script from "./SizeGuide.vue?vue&type=script&lang=js&"
export * from "./SizeGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/app/components/UI/UiIcon.vue').default})
